import { BaseUser } from "./base-user.model";

export class BaseUserMapper {
  public static map(userData: any): BaseUser {
    return new BaseUser(
      userData.id,
      userData.username,
      userData.firstName,
      userData.lastName,
    );
  }
}
